"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeatPlanSpaceShapeLabel = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
const getSeatPlanSpaceShapeLabel = shape => {
  switch (shape) {
    case _hopsSdkJs.SeatPlanSpaceShapes.Circle:
    case _hopsSdkJs.SeatPlanSpaceShapes.Faced:
      return "Available seat";
    case _hopsSdkJs.SeatPlanSpaceShapes.Divider:
      return "Table";
    default:
      return null;
  }
};
exports.getSeatPlanSpaceShapeLabel = getSeatPlanSpaceShapeLabel;